<template>
    <div class="Gift">
        <div class="first-screen wrapper-mobile">
            <div class="container-fluid">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="breadcrumbs">
                                <a class="breadcrumbs__item" href="#">Главная</a
                                ><span class="breadcrumbs__sep"> / </span>
                                <a class="breadcrumbs__item" href="#">Русский</a
                                ><span class="breadcrumbs__sep"> / </span>
                                <a
                                    class="breadcrumbs__item breadcrumbs__item--current"
                                    href="#"
                                    >Каллиграфия</a
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-7">
                            <h1 class="first-screen__title">
                                Поздравьте ребенка с&nbsp;Праздником!
                            </h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-7">
                            <p class="first-screen__desc">
                                Знания&nbsp;&mdash; лучший подарок! Именной
                                электронный сертификат на&nbsp;любые курсы
                                платформы Полиглотики
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <a
                                class="btn btn-info ui-btn btn--big-blue"
                                href="#choose-course"
                            >
                                Выбрать
                                <span class="hide-mobile">подарочный</span>
                                сертификат
                                <img
                                    src="@/assets/hometeacher/images/arrow-to-right.png"
                                    class="btn__icon hide-mobile"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="gift-steps">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="gift-steps__title">
                            Как подарить сертификат
                        </h2>
                    </div>
                </div>
                <div class="gift-steps__bg">
                    <div class="row">
                        <div class="col-md-4 col-12">
                            <div class="step step--one">
                                <h3 class="step__title">
                                    Оформите<br />сертификат
                                </h3>
                                <p class="step__description">
                                    Выберите курс или абонемент для подарочного
                                    сертификата.
                                </p>
                                <p class="step__description">
                                    Заполните поля и оплатите заказ.
                                </p>
                            </div>
                        </div>
                        <div class="col-md-4 col-12">
                            <div class="step step--two">
                                <h3 class="step__title">
                                    Подарите<br />сертификат
                                </h3>
                                <p class="step__description">
                                    Получите именной сертификат на ваш email.
                                </p>
                                <p class="step__description">
                                    Распечатайте его или отправьте в электронном
                                    виде.
                                </p>
                            </div>
                        </div>
                        <div class="col-md-4 col-12">
                            <div class="step step--three">
                                <h3 class="step__title">
                                    Получатель<br />активирует
                                </h3>
                                <p class="step__description">
                                    Получатель регистрируется на платформе и
                                    активирует сертификат.
                                </p>
                                <p class="step__description">
                                    Приступает к обучению.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="course-type" id="course-type">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2
                            class="h2 course-type__h2 wrapper-mobile"
                            id="choose-course"
                        >
                            1. Выберите тип курса или абонемент
                        </h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <div
                            v-if="!isCourseChoosed"
                            v-bind:class="{
                                'course-type__item-toggled': showCourseChoise,
                            }"
                            class="course-type__item course-type__item--hometeacher"
                        >
                            <div class="course-type__image-wrapper">
                                <img
                                    src="@/assets/hometeacher/images/hometeacher.png"
                                    alt="HomeTeacher"
                                    class="course-type__image"
                                />
                            </div>
                            <button
                                class="btn course-type__btn course-type__btn--hometeacher"
                                @click="toggleCourseChoise"
                            >
                                {{ $t('select_course') }}
                            </button>
                            <div v-if="showCourseChoise" class="course-choice">
                                <div class="course-choice__wrapper">
                                    <div class="course-choice__header">
                                        Выбор курса HomeTeacher
                                    </div>
                                    <img
                                        v-on:click="toggleCourseChoise"
                                        class="course-choice__close-btn"
                                        src="@/assets/hometeacher/images/x-circle.svg"
                                        alt="Закрыть"
                                    />
                                </div>
                                <CoursesList />
                            </div>
                            <p class="course-type__price">
                                от 490 руб/курс
                            </p>
                            <p class="course-type__desc">
                                Это образовательная онлайн-платформа с
                                видеоуроками для детей от 1 года до 12 лет.<br />
                                <a class="course-type__open-desc" href="">
                                    Подробнее
                                    <img
                                        src="@/assets/hometeacher/images/arrow-down.png"
                                        alt=""
                                    />
                                </a>
                            </p>
                        </div>
                        <div
                            v-if="isCourseChoosed"
                            class="course-type__item course-type__item--hometeacher course-type__item--chosen"
                        >
                            <img
                                src="@/assets/hometeacher/images/hometeacher.png"
                                alt="HomeTeacher"
                                class="course-type__image"
                            />

                            <div class="chosen-course-info">
                                <div
                                    class="chosen-course-info__course-name-label"
                                >
                                    Выбран курс:
                                </div>
                                <div class="chosen-course-info__course-name">
                                    {{ course.course }}
                                </div>
                                <div class="chosen-course-info__desc">
                                    <span class="chosen-course-info__label"
                                        >{{ $t('Language') }}: </span
                                    ><span class="chosen-course-info__text">
                                        {{
                                            course.idlanguage === 1
                                                ? "Английский"
                                                : course.idlanguage === 2
                                                ? "Испанский"
                                                : course.idlanguage === 3
                                                ? "Немецкий"
                                                : course.idlanguage === 4
                                                ? "Французкий"
                                                : course.idlanguage === 5
                                                ? "Китайский"
                                                : course.idlanguage === 6
                                                ? "Русский"
                                                : "Язык"
                                        }}
                                    </span>
                                </div>
                                <div class="chosen-course-info__desc">
                                    <span class="chosen-course-info__label"
                                        >{{ $t('Age') }}: </span
                                    ><span class="chosen-course-info__text">
                                        <span
                                            v-for="age in course.ages"
                                            :key="age.idage"
                                            >{{ age.age }}
                                        </span>
                                    </span>
                                </div>
                                <div class="chosen-course-info__desc">
                                    <span class="chosen-course-info__label"
                                        >{{ $t('Lessons') }}: </span
                                    ><span class="chosen-course-info__text">
                                        {{ course.lessonscount }}
                                    </span>
                                </div>
                                <div class="chosen-course-info__desc">
                                    <span class="chosen-course-info__label"
                                        >{{ $t('Duration') }}: </span
                                    ><span class="chosen-course-info__text"
                                        >{{ course.duration }}
                                    </span>
                                </div>
                                <div
                                    class="chosen-course-info__desc chosen-course-info__desc--price"
                                >
                                    <span
                                        class="chosen-course-info__text chosen-course-info__text--price-new"
                                        >{{ fixedNewFullPrice }}<span class="chosen-course-info__text--rub">{{ $t('cur') }}</span></span
                                    ><span
                                        class="chosen-course-info__text chosen-course-info__text--price-old"
                                        >{{ fixedOldFullPrice }}<span class="chosen-course-info__text--rub">{{ $t('cur') }}</span>
                                    </span>
                                </div>
                                <div
                                    class="chosen-course-info__close"
                                    @click="isCourseChoosed = false"
                                >
                                    отменить
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div
                            class="course-type__item course-type__item--onlineteacher"
                        >
                            <img
                                src="@/assets/hometeacher/images/onlineteacher2.png"
                                alt="OnlineTeacher"
                                class="course-type__image"
                            />
                            <a
                                class="btn course-type__btn course-type__btn--onlineteacher"
                                href=""
                                >Выбрать абонемент</a
                            >
                            <p class="course-type__price">
                                от 990 руб/месяц
                            </p>
                            <p class="course-type__desc">
                                Занятия максимально приближены к очному обучению
                                и предполагают занятия в режиме реального
                                времени.<br />
                                <a class="course-type__open-desc" href="">
                                    Подробнее
                                    <img
                                        src="@/assets/hometeacher/images/arrow-down.png"
                                        alt=""
                                    />
                                </a>
                            </p>
                            <div class="course-type__placeholder">
                                <img class="course-type__placeholder-image" src="@/assets/hometeacher/images/bird-8.png" alt="">
                                <div class="course-type__placeholder-title">
                                    Скоро
                                </div>
                                <div class="course-type__placeholder-text">
                                    Совсем скоро мы добавим возможность дарить абонементы
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3">
                        <div class="course-type__onlineteacher hide-mobile">
                            <img
                                src="@/assets/hometeacher/images/certificate-1.png"
                                alt="Сертификат на 3 месяца"
                                class="course-type__certificate-image"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="for-whom wrapper-mobile">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="h2 for-whom__h2">2. Для кого сертификат</h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-9">
                        <input
                            class="form-control form-control--for-from"
                            type="text"
                            placeholder="Введите имя и фамилию ребенка"
                            v-model="recipent.name"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-lg-9">
                        <p class="for-whom__input-title">
                            Напишите поздравление на сертификате<br
                                class="hide-desktop"
                            />
                            <span class="title__caption">(необязательно)</span>
                        </p>
                        <textarea
                            class="form-control form-control--for-from"
                            placeholder="Поздравляю с праздником! Пусть твоя жизнь будет полна удивительных открытий и новых знаний!"
                            rows="5"
                            v-model="recipent.text"
                        ></textarea>
                        <p class="input-caption">
                            не более 1024 символов
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid blue-bg">
            <div class="contacts-form wrapper-mobile">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="h2 h2--contacts-form">3. Ваши данные</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <input
                                class="form-control form-control--contacts"
                                type="text"
                                placeholder="Ваше имя"
                                v-model="giver.firstName"
                            />

                            <input
                                class="form-control form-control--contacts form-control--surname"
                                type="email"
                                placeholder="Фамилия"
                                v-model="giver.lastName"
                            />
                        </div>
                        <div class="col-12 col-lg-4">
                            <input
                                class="form-control form-control--contacts"
                                type="email"
                                placeholder="E-mail"
                                v-model="giver.email"
                            />
                            <p class="input-caption">
                                На этот e-mail придет чек и электронный
                                сертификат
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="order-info wrapper-mobile">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="h2 h2--order-info">
                                4. Информация по заказу
                            </h2>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-9">
                            <div class="order-info__group">
                                <div
                                    class="order-info__item order-info__item--desktop"
                                >
                                    <p class="order-info__title">
                                        Тип сертификата:
                                    </p>
                                    <p class="order-info__text">
                                        HomeTeacher
                                    </p>
                                </div>
                                <div
                                    class="order-info__item-mobile hide-desktop"
                                >
                                    <p class="order-info__title-mobile">
                                        Тип сертификата:
                                    </p>
                                    <p class="order-info__text-mobile">
                                        HomeTeacher
                                    </p>
                                    <div class="order-info__cert-type-mobile">
                                        <img
                                            src="@/assets/hometeacher/images/certificate-1.png"
                                            alt="Сертификат на 3 месяца"
                                            class="order-info__cert-type-image"
                                        />
                                    </div>
                                </div>
                                <div class="order-info__item">
                                    <p class="order-info__title">
                                        Курс:
                                    </p>
                                    <div class="order-info__text">
                                        {{ course.course }}<br />
                                        <div class="order-info__course-text">
                                            <span
                                                class="order-info__text--small"
                                                >{{ $t('Language') }}:
                                            </span>
                                            <span
                                                class="order-info__text--bold"
                                            >
                                                {{
                                                    course.idlanguage === 1
                                                        ? "Английский"
                                                        : course.idlanguage ===
                                                          2
                                                        ? "Испанский"
                                                        : course.idlanguage ===
                                                          3
                                                        ? "Немецкий"
                                                        : course.idlanguage ===
                                                          4
                                                        ? "Французкий"
                                                        : course.idlanguage ===
                                                          5
                                                        ? "Китайский"
                                                        : course.idlanguage ===
                                                          6
                                                        ? "Русский"
                                                        : ""
                                                }}</span
                                            >
                                        </div>
                                        <div class="order-info__course-text">
                                            <span
                                                class="order-info__text--small"
                                                >{{ $t('Age') }}:
                                            </span>
                                            <span class="order-info__text--bold"
                                                ><span
                                                    v-for="age in course.ages"
                                                    :key="age.idage"
                                                    >{{ age.age }}
                                                </span></span
                                            >
                                        </div>
                                        <div class="order-info__course-text">
                                            <span
                                                class="order-info__text--small"
                                                >{{ $t('Lessons') }}:
                                            </span>
                                            <span
                                                class="order-info__text--bold"
                                                >{{ course.lessonscount }}</span
                                            >
                                        </div>
                                        <div class="order-info__course-text">
                                            <span
                                                class="order-info__text--small"
                                                >{{ $t('Duration') }}:
                                            </span>
                                            <span
                                                class="order-info__text--bold"
                                                >{{ course.duration }}</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="order-info__group">
                                <div class="order-info__item">
                                    <p class="order-info__title">
                                        Получатель:
                                    </p>
                                    <p class="order-info__text">
                                        {{ recipent.name || "Имя получателя" }}
                                    </p>
                                </div>
                                <div class="order-info__item">
                                    <p class="order-info__title">
                                        Поздравление:
                                    </p>
                                    <p
                                        class="order-info__text order-info__text--italic"
                                    >
                                        {{
                                            recipent.text ||
                                                `Поздравляю с праздником! Пусть твоя жизнь будет полна удивительных открытий и новых знаний!`
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div class="order-info__group">
                                <div class="order-info__item">
                                    <p class="order-info__title">
                                        Даритель:
                                    </p>
                                    <p class="order-info__text">
                                        {{
                                            giver.firstName || giver.lastName
                                                ? giver.firstName +
                                                  " " +
                                                  giver.lastName
                                                : "Ваше имя"
                                        }}
                                    </p>
                                </div>
                                <div class="order-info__item">
                                    <p class="order-info__title">
                                        E-mail:
                                    </p>
                                    <p class="order-info__text">
                                        {{
                                            giver.email || "Ваш адрес эл. почты"
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div class="order-info__item">
                                <p
                                    class="order-info__title order-info__title--price"
                                >
                                    Итого к оплате:
                                </p>
                                <p class="order-info__text">
                                    <span class="order-info__price-new">{{
                                        course.full_price ? fixedNewFullPrice : "0"
                                    }}</span
                                    ><span class="order-info__price-old">{{
                                        course.full_price_before ? fixedOldFullPrice : ""
                                    }}</span>
                                </p>
                            </div>
                        </div>

                        <div class="col-12 col-lg-3">
                            <img
                                src="@/assets/hometeacher/images/certificate-1.png"
                                alt="Сертификат на 3 месяца"
                                class="hide-mobile"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-5">
                            <a
                                class="btn btn-info ui-btn btn--big-blue"
                                href="#"
                            >
                                {{ $t('go_to_payment') }}
                                <img
                                    src="@/assets/hometeacher/images/arrow-to-right.png"
                                    class="btn__icon"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CoursesList from "./CoursesList";
import courseApi from "../../data/CourseApi";

export default {
    name: "Gift",
    components: { CoursesList },
    data() {
        return {
            loading: true,
            course: {},
            showCourseChoise: false,
            isCourseChoosed: false,
            recipent: {
                name: "",
                text: "",
                choosedCourseId: "",
            },
            giver: {
                firstName: "",
                lastName: "",
                email: "",
            },
        };
    },
    watch: {
        isCourseChoosed: function() {
            courseApi
                .fetchCourse(this.recipent.choosedCourseId)
                .then((response) => {
                    this.course = response;
                    this.loading = false;
                })
                .catch((error) => {
                    let data = error.response.data;
                    this.error = this.pretty(data);
                    this.loading = false;
                });
        },
    },
    methods: {
        toggleCourseChoise: function() {
            this.showCourseChoise = !this.showCourseChoise;
        },
    },
    computed: {
        //     joinedAges: function() {
        //         if (this.loading) {
        //             console.log("not loaded");
        //             return null;
        //         } else {
        //             console.log(this.course.ages);
        //         }
        //     },
        //     reversedName: function() {
        //         if (this.loading) {
        //             console.log("not loaded");
        //             return null;
        //         } else {
        //             return this.course.course.toUpperCase();
        //         }
        //     },
        fixedNewFullPrice: function() {
            if (!this.loading) {
                return parseFloat(this.course.full_price).toFixed(0);
            }
            return null;
        },
        fixedOldFullPrice: function() {
            if (!this.loading) {
                return parseFloat(this.course.full_price_before).toFixed(0);
            }
            return null;
        },
    },
    mounted() {
        this.loading = false;
        console.log("MOUNTED");
    },
};
</script>

<style scoped src="@/assets/hometeacher/css/main.css"></style>

<style scoped>
.breadcrumbs__item {
    font-size: 14px;
    text-decoration: underline;
}

.breadcrumbs__item--current {
    text-decoration: none;
}

.btn__icon {
    margin-left: 14px;
    height: 15px;
}

.gift-steps {
    height: fit-content;
    border-bottom: #d7e1e5 1px solid;
    padding-bottom: 120px;
}

.course-type__placeholder {
    height: 100%;
    width: 100%;
    background-color: rgba(79, 77, 92, 0.9);
    position: absolute;
    top: 0;
    padding-left: 35px;
    padding-right: 35px;
    padding-top: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.course-type__placeholder-image {
    margin-bottom: 10px;
}

.course-type__placeholder-title {
    text-align: center;
    font-family: 'Manrope Bold';
    font-size: 24px;
    color: #fff;
}

.course-type__placeholder-text {
    text-align: center;
    font-size: 16px;
    color: #fff;
}

.course-type__item {
    border: solid 1px #d7e1e5;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 41px;
    padding-left: 30px;
    padding-right: 30px;
    position: relative;
    height: 379px;
    min-width: 350px;
}

.course-choice__close-btn {
    position: absolute;
    right: 40px;
    transition: opacity 0.3s;
}

.course-choice__close-btn:hover {
    opacity: 0.5;
}

.course-type__item--chosen {
    align-items: flex-start;
    background-color: #e6f0f2;
}

.course-type__item-toggled {
    background-color: #e6eff2;
}

.course-type__item:hover {
    box-shadow: 0 0 12px 0 rgba(79, 77, 92, 0.3);
    transition: box-shadow 0.2s;
}

.course-type__item--onlineteacher {
    border: none;
}

.course-type__item--onlineteacher:hover {
    box-shadow: none;
}

.course-type__image-wrapper {
    /* padding-bottom: ; */
}

.course-type__image {
    margin: 0 auto;
    margin-bottom: 0;
    height: 53px;
}

.course-type__btn {
    border-radius: 20px;
    font-size: 18px;
    font-family: "Manrope Bold";
    padding-left: 48px;
    padding-right: 48px;
    color: #fff;
    margin-bottom: 24px;
    margin-top: 15px;
}

.course-type__btn--hometeacher {
    background: #5ab947;
    text-shadow: 0.7px 0.7px 0 #2d6e20;
}

.course-type__btn--onlineteacher {
    background: #00b4f1;
    text-shadow: 0.7px 0.7px 0 #0489c7;
}

.course-type__price {
    font-family: "Manrope Book";
    margin-bottom: 12px;
}

.form-control--for-from {
    padding-top: 26px;
    padding-bottom: 26px;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 18px;
}

.input-caption {
    color: #8b8496;
    margin-top: 13px;
    line-height: 1.13;
}

.contacts-form {
    padding-bottom: 72px;
    border-bottom: 1px solid #cdcbcf;
}

/* .order-info__text--italic {
    font-family: "Manrope Book Italic";
} */

.order-info__text--small {
    font-size: 16px;
    line-height: 1.13;
    margin-bottom: 0;
    font-family: "Manrope Light";
    color: #8b8496;
}

.order-info__text--bold {
    font-size: 16px;
    line-height: 1.13;
    font-family: "Manrope Bold";
    color: #4f4d5c;
}

.order-info__course-text {
    line-height: 0;
}

.order-info {
    padding-bottom: 104px;
}

.course-choice {
    width: 1300px;
    height: 500px;
    background: #e6eff2;
    z-index: 15;
    position: absolute;
    top: 109px;
    left: -100px;
}

.course-choice__wrapper {
    height: 150px;
    display: flex;
    align-items: center;
    padding-left: 100px;
}

.course-choice__header {
    font-size: 35px;
    font-family: "Manrope Bold";
}

.course-type__certificate-image {
    z-index: 16;
    position: relative;
}

.chosen-course-info {
    display: block;
    flex-direction: column;
}

.chosen-course-info__course-name-label {
    font-size: 18px;
    font-family: "Manrope Bold";
    color: #8b8496;
    margin-bottom: 0px;
    line-height: 1;
    margin-top: 9px;
}

.chosen-course-info__course-name {
    font-size: 21px;
    font-family: "Manrope Bold";
    line-height: 1.15;
    margin-bottom: 16px;
    margin-top: 8px;
}

.chosen-course-info__desc {
    line-height: 1;
    margin-bottom: 2px;
}

.chosen-course-info__text,
.chosen-course-info__label {
    font-size: 16px;
}

.chosen-course-info__text {
    font-family: "Manrope Bold";
}

.chosen-course-info__close {
    text-align: right;
    position: absolute;
    bottom: 19px;
    right: 35px;
    cursor: default;
    text-decoration: underline;
}

.chosen-course-info__close::after {
    content: "";
    display: inline-block;
    position: relative;
    top: 2px;
    height: 16px;
    width: 16px;
    background-image: url("~@/assets/hometeacher/images/trash-2.svg");
    background-size: 16px;
}

.chosen-course-info__desc--price {
    margin-top: 16px;
}

.chosen-course-info__text--price-new {
    font-size: 30px;
    color: #000;
    padding-right: 12px;
}

.chosen-course-info__text--rub {
    font-size: 16px;
}

@media screen and (min-width: 320px) {
    .first-screen__title {
        font-size: 42px;
        margin-top: 35px;
        font-family: "Manrope Bold";
        color: #f15b22;
        line-height: normal;
    }

    .h2 {
        font-family: "Manrope Bold";
        font-size: 27px;
    }

    input {
        width: 100%;
    }

    .hide-mobile {
        display: none;
    }

    .hide-desktop {
        display: auto;
    }

    .first-screen {
        height: 650px;
        /* padding-bottom: 140px; */
        background: url("~@/assets/hometeacher/images/certificate-pattern-bg.png");
        /* background-size: 100%, 100%; */
        background-repeat: no-repeat;
        background-position: center top;
    }

    .first-screen__desc {
        color: #231c37;
        line-height: 1.71;
        font-family: "Manrope Book";
        font-size: 21px;
        margin-top: 35px;
        margin-left: 0;
    }

    .wrapper-mobile {
        padding-left: 20px;
        padding-right: 20px;
    }

    .breadcrumbs {
        margin-left: 0;
    }

    .btn--big-blue {
        margin-top: 50px;
        font-size: 21px;
        border-radius: 20px;
        background-color: #00b4f1;
        font-family: "Manrope Bold";
        color: rgba(255, 255, 255, 0.8);
        padding-bottom: 24px;
        padding-top: 24px;
        width: 100%;
    }

    .gift-steps__title {
        font-family: "Manrope Bold";
        color: #f15b22;
        line-height: 1.17;
        font-size: 36px;
        margin-top: 108px;
        /* margin-bottom: 35px; */
        text-align: center;
    }

    .gift-steps__bg {
        height: 840px;
        background-image: url("~@/assets/hometeacher/images/steps-mobile.png");
        background-repeat: no-repeat;
        background-position: center top;
        position: relative;
        margin-top: 10px;
    }

    .step__title {
        font-size: 24px;
        line-height: 1.25;
        font-family: "Manrope Bold";
    }

    .step__description {
        font-size: 18px;
        max-width: 244px;
        line-height: 1.33;
        font-family: "Manrope Book";
    }

    .step {
        position: absolute;
        /* top: 100px; */
        left: 110px;
    }

    .step--one {
        /* left: 82px; */
        top: 48px;
    }

    .step--two {
        /* left: 105px; */
        top: 354px;
    }

    .step--three {
        /* left: 125px; */
        top: 642px;
    }

    .step--three .step__description {
        width: 215px;
    }

    .course-type__h2 {
        margin-top: 80px;
        margin-bottom: 40px;
        line-height: 1.11;
        font-size: 27px;
    }

    .course-type__desc {
        line-height: 1.13;
        font-size: 16px;
        border-top: 1px solid #d7e1e5;
        padding-top: 24px;
    }

    .course-type__open-desc {
        display: inline-block;
        margin-top: 10px;
        color: #0493c3;
        border-bottom: #0493c3 1px dotted;
    }

    .for-whom__h2 {
        margin-top: 70px;
        margin-bottom: 34px;
    }

    .title__caption {
        font-size: 15px;
        color: #8b8496;
        font-family: "Intro";
    }

    .for-whom__input-title {
        margin-top: 54px;
        margin-bottom: 15px;
        font-size: 24px;
        font-family: "Manrope Bold";
        color: #000;
        line-height: 1.13;
    }

    .for-whom {
        padding-bottom: 90px;
    }

    .h2--contacts-form {
        margin-top: 70px;
        margin-bottom: 50px;
    }

    .form-control--contacts {
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 30px;
        padding-right: 30px;
        font-size: 16px;
        margin-bottom: 34px;
    }

    /* .form-control--contacts:last-child {
        margin-bottom: 0;
    } */

    .form-control--surname {
        margin-top: 0;
    }

    .h2--order-info {
        margin-top: 89px;
        margin-bottom: 48px;
    }

    .order-info__item-mobile {
        padding-bottom: 30px;
        padding-top: 30px;
        background-color: #d7e1e5;
        margin-left: -20px;
        margin-right: -20px;
        padding-left: 20px;
        padding-right: 20px;
        margin-bottom: 31px;
        position: relative;
    }

    .order-info__title-mobile {
        font-size: 16px;
        color: #8b8496;
        margin-bottom: 0;
        margin-bottom: 5px;
        line-height: 1;
    }

    .order-info__text-mobile {
        font-size: 27px;
        color: #231c37;
        margin-bottom: 0;
        font-family: "Manrope Bold";
        line-height: 1;
    }

    .order-info__cert-type-mobile {
        height: 145px;
        position: absolute;
        right: 0;
        top: -18px;
    }

    .order-info__cert-type-image {
        height: 145px;
    }

    .order-info__cert-type-mobile::after {
        content: "Увеличить";
        font-family: "Manrope Bold";
        font-size: 14px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.8);
        position: absolute;
        left: 2px;
        bottom: 4px;
        display: flex;
        height: 36px;
        width: 98px;
        justify-content: center;
        align-items: center;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .order-info__item {
        display: flex;
        flex-direction: column;
        /* padding-bottom: 34px;
        padding-top: 32px; */
    }

    .order-info__item--desktop {
        display: none;
    }

    .order-info__title,
    .order-info__text {
        margin-bottom: 16px;
    }

    .order-info__title {
        width: 190px;
        font-size: 16px;
        color: #8b8496;
        padding-top: 3px;
        font-family: "Manrope Book";
        margin-bottom: 10px;
        line-height: 1;
    }

    .order-info__text {
        font-size: 21px;
        font-family: "Manrope Bold";
        color: #231c37;
        max-width: 638px;
        line-height: 1;
    }

    .order-info__group {
        margin-bottom: 0;
        border-bottom: 1px solid #cdcbcf;
        margin-left: -20px;
        margin-right: -20px;
        padding-right: 20px;
        padding-left: 20px;
        padding-bottom: 32px;
        padding-top: 32px;
    }

    .order-info__title--price {
        padding-top: 0;
        margin-top: 50px;
        font-size: 21px;
        font-family: "Manrope Bold";
    }

    .order-info__price-new {
        color: #ed1c24;
        font-size: 30px;
        margin-right: 15px;
    }

    .order-info__price-old {
        color: #8b8496;
        font-size: 21px;
        text-decoration: line-through;
    }
}

@media screen and (min-width: 641px) {
    .wrapper-mobile {
        padding-left: 0;
        padding-right: 0;
    }

    .hide-desktop {
        display: none;
    }

    .hide-mobile {
        display: inline-block;
    }

    .breadcrumbs {
        margin-top: 24px;
    }

    .first-screen__title {
        margin-top: 96px;
        font-size: 60px;
    }

    .h2 {
        font-family: "Manrope Bold";
        font-size: 30px;
    }

    .first-screen__desc {
        font-size: 27px;
        margin-top: 56px;
        margin-left: 40px;
    }

    .btn--big-blue {
        margin-top: 71px;
        font-size: 21px;
        border-radius: 20px;
        background-color: #00b4f1;
        font-family: "Manrope Bold";
        color: rgba(255, 255, 255, 0.8);
        width: auto;
        padding-left: 51px;
        padding-right: 35px;
    }

    .first-screen {
        height: 740px;
        /* padding-bottom: 140px; */
        background: url("~@/assets/hometeacher/images/certificate-kids-bg.png"),
            url("~@/assets/hometeacher/images/certificate-pattern-bg.png");
        /* background-size: 100%, 100%; */
        background-repeat: no-repeat, no-repeat;
        background-position: center top, center top;
    }

    .gift-steps__title {
        font-size: 36px;
        margin-top: 108px;
        margin-bottom: 105px;
        text-align-last: left;
    }

    .gift-steps__bg {
        height: 310px;
        background-image: url("~@/assets/hometeacher/images/gift-steps.png");
        background-repeat: no-repeat;
        position: relative;
        background-size: 100%;
    }

    .step__title {
        font-size: 24px;
        line-height: 1.25;
        font-family: "Manrope Bold";
    }

    .step__description {
        font-size: 18px;
        max-width: 244px;
        line-height: 1.33;
    }

    .step {
        position: absolute;
        top: 100px;
    }

    .step--one {
        left: 82px;
    }

    .step--two {
        left: 105px;
    }

    .step--three {
        left: 125px;
    }

    .course-type__h2 {
        margin-top: 102px;
        margin-bottom: 45px;
    }

    .for-whom__h2 {
        margin-top: 104px;
        margin-bottom: 45px;
    }

    .for-whom__input-title {
        margin-top: 72px;
        margin-bottom: 11px;
        font-size: 24px;
        font-family: "Manrope Bold";
        color: #000;
    }

    .for-whom {
        padding-bottom: 101px;
    }

    .h2--contacts-form {
        margin-top: 87px;
        margin-bottom: 68px;
    }

    .form-control--contacts {
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 30px;
        padding-right: 30px;
        font-size: 16px;
        margin-bottom: 0;
    }

    .form-control--surname {
        margin-top: 34px;
    }

    .h2--order-info {
        margin-top: 86px;
        margin-bottom: 48px;
    }

    .order-info__item--desktop {
        display: flex;
    }

    .order-info__item {
        display: flex;
        flex-direction: row;
    }

    .order-info__title,
    .order-info__text {
        margin-bottom: 16px;
    }

    .order-info__title {
        width: 190px;
        font-size: 18px;
        color: #8b8496;
        padding-top: 3px;
        font-family: "Manrope Book";
        line-height: 1.14;
        margin-bottom: 0;
    }

    .order-info__text {
        font-size: 21px;
        font-family: "Manrope Bold";
        color: #231c37;
        max-width: 635px;
        line-height: 1.14;
    }

    .order-info__group {
        margin-bottom: 40px;
        border-bottom: none;
        margin-left: 0;
        margin-right: 0;
        padding-right: 0;
        padding-left: 0;
        padding-bottom: 0;
        padding-top: 0;
    }

    .order-info__title--price {
        padding-top: 12px;
        font-size: 21px;
        margin-top: 0;
    }

    .order-info__price-new {
        color: #ed1c24;
        font-size: 30px;
        margin-right: 15px;
        line-height: 1.3;
    }

    .order-info__price-old {
        color: #8b8496;
        font-size: 21px;
        text-decoration: line-through;
    }
}
</style>
